<script>

  let error = false;
  let success = false;
  let requestInProgress = false;

  // Request API.
  async function postRequest (authCode, newPassword, newPassConfirm) {
    try {
      const request = await fetch('https://api.ordrk.com/auth/reset-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          code: authCode, // code contained in the reset link of step 3.
          password: newPassword,
          passwordConfirmation: newPassConfirm,
        }),
      });

      const response = await request.json();

      if(!request.ok) {
        let errorDetails = response.data[0].messages[0].message;
        throw new Error(`${errorDetails}`);
      } else {
        success = 'Password has been reset successfully.';
      }

    } catch(err) {
      if(err = 'TypeError: Failed to fetch') {
        error = 'Could not connect with server. Please make sure you are online.'
      } else {
        error = err;
      } 
      console.error(err);
    };
  };

  const handleSubmit = (e) => {
    console.log('triggered');
    // Retrieve User Input
    const formData = new FormData(e.target);
    let userInput = {};
    for(let pair of formData.entries()) {
      userInput[pair[0]] = pair[1];
    }

    // Perform local validation
    if(userInput.password == userInput.passwordConfirmation) {
      requestInProgress = true;
      postRequest(code, userInput.password, userInput.passwordConfirmation).then(() => requestInProgress = false);
    } else {
      error = 'Passwords do not match.';
    }
  }

  const setCustomError = (event) => {
    if (event.target.validity.tooShort) {
      event.target.setCustomValidity('Your password should be 8 characters or more');
    }
  };

  // Retrieve code from param
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');

</script>

{#if code}
  <section id="free-pricing" class="py-5">
    <div class="container py-5">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body p-4">
            <div class="card-header bg-transparent" style="font-size: 20pt; border: none;">Reset Password</div>

            <form on:submit|preventDefault={handleSubmit}>

              <div class="form-group">
                <label for="password">Password</label>
                <input on:invalid={setCustomError} on:change={(e) => {e.target.setCustomValidity('');}} class="form-control" type="password" minlength="8" name="password" placeholder="Enter your new password" required>
              </div>

              <div class="form-group">
                <label for="passwordConfirmation">Password Confirmation</label>
                <input class="form-control" type="password" name="passwordConfirmation" placeholder="Repeat your new password" required>
              </div>

              <input type="hidden" value={code} name="code" />
    

            <div class="d-grid gap-2">
              <button type="button" class="btn btn-card {requestInProgress && 'is-loading'}" disabled={requestInProgress} >Change Password</button>
            </div>

          </form>

          {#if success}
          <div class="notification is-success is-light box-container" on:click={() => {success = false;}}>
            <button class="delete"></button>
            {success}
          </div>
        {/if}
    
        {#if error}
          <div class="notification is-danger is-light box-container" on:click={() => {error = false;}}>
            <button class="delete"></button>
            {error}
          </div>
        {/if}


          </div>
        </div>
      </div>
      
    </div>
  </section>
{:else}
  <div class="container" style="margin-top: 124px;">
    <div class="box columns" style="padding: 3em; max-width: 600px; margin: auto;">
      <div class="column is-2 has-text-centered">
        <span class="icon is-large" style="margin-top: 0.5em; color: #393D97;">
          <i class="fas fa-envelope fa-4x"></i>
        </span>
      </div>
      <div class="column has-text-centered">
        <div class="card">
          <div class="card-body" style="padding: 3em;">
            <h3>Invalid code</h3>
            <p>Kindly make sure that you have opened the correct link.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .form-control {
    margin-bottom: 1em;
  }
</style>